// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O6wn3","name":"styles_name__3esVB","phone":"styles_phone__2kTeD"};